import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import classes from "./Banner.module.scss";
import { R_ADD_BANNERS } from "../../constants/routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Spinner from "../../Components/Spinner";
import BannerTable from "./BannerTable/BannerTable";
import ModalDeleteBanner from "./ModalDeleteBanner/ModalDeleteBanner";
import { useBannerActions } from "./AddBanner/hooks/useBannerActions";
import ButtonActions from "../../Components/Buttons/ButtonActions/ButtonActions";
import Header from "../../Components/Header/Header";

const Banners = () => {
  const history = useHistory();

  const [modalDelete, setModalDelete] = useState(false);

  // guarda qual banner foi selecionado para deletar
  const [selectedBanner, setSelectedBanner] = useState(null);

  const { getBanners, bannersList, setBannersList, isLoadingBanner } =
    useBannerActions();

  useEffect(() => {
    getBanners();
  }, []);

  return (
    <div>
      <div className={classes.BannerList}>
        <Header text="Banner Afinando" />

        <ButtonActions
          variant="primary"
          style={{margin: "50px 0"}}
          onClick={() => history.push(R_ADD_BANNERS)}
          text="Novo Banner"
          icon={<PlusOutlined />}
        />
      </div>
      {isLoadingBanner ? (
        <Spinner />
      ) : bannersList?.length > 0 ? (
        <BannerTable
          setModalDelete={setModalDelete}
          bannersList={bannersList}
          setSelectedBanner={setSelectedBanner}
        />
      ) : (
        <p>Nenhum banner encontrado</p>
      )}

      <ModalDeleteBanner
        setModalDelete={setModalDelete}
        modalDelete={modalDelete}
        selectedBanner={selectedBanner}
      />
    </div>
  );
};

export default Banners;
